let audioContext = null;
let oscillator = null;
let gainNode = null;
let stopRequested = false;

export const playMorseCodeAudio = (groups, wpm, onComplete) => {
  if (audioContext) {
    stopMorseAudio(); // Stop any currently playing audio before starting new
  }

  const morseCodeDict = {
    A: ".-",
    B: "-...",
    C: "-.-.",
    D: "-..",
    E: ".",
    F: "..-.",
    G: "--.",
    H: "....",
    I: "..",
    J: ".---",
    K: "-.-",
    L: ".-..",
    M: "--",
    N: "-.",
    O: "---",
    P: ".--.",
    Q: "--.-",
    R: ".-.",
    S: "...",
    T: "-",
    U: "..-",
    V: "...-",
    W: ".--",
    X: "-..-",
    Y: "-.--",
    Z: "--..",
    1: ".----",
    2: "..---",
    3: "...--",
    4: "....-",
    5: ".....",
    6: "-....",
    7: "--...",
    8: "---..",
    9: "----.",
    0: "-----",
    "‘": ".----.",
    "“": ".-..-.",
    ":": "---...",
    ";": "-.-.-.",
    ",": "--..--",
    "/": "-..-.",
    "-": "-....-",
    "(": "-.--.",
    ")": "-.--.-",
    ".": ".-.-.-",
    "?": "..--..",
    "=": "-...-",
    "+": ".-.-.",
    "@": ".--.-.",
  };

  // Timing calculations based on WPM
  const dotLength = 1.2 / wpm;
  const dashLength = dotLength * 3;
  const spaceBetweenSymbols = dotLength;
  const spaceBetweenLetters = dotLength * 3;
  const spaceBetweenWords = dotLength * 7;

  // Initialize audio context
  audioContext = new (window.AudioContext || window.webkitAudioContext)();
  oscillator = audioContext.createOscillator();
  gainNode = audioContext.createGain();

  oscillator.type = "sine";
  oscillator.frequency.setValueAtTime(550, audioContext.currentTime);
  gainNode.gain.setValueAtTime(0, audioContext.currentTime); // Start silent

  let time = audioContext.currentTime;
  stopRequested = false; // Reset stop flag

  const scheduleBeep = (length) => {
    if (stopRequested) return; // Stop playback if requested

    gainNode.gain.setValueAtTime(1, time);
    time += length;
    gainNode.gain.setValueAtTime(0, time);
  };

  // Loop through each group and play it sequentially
  groups.forEach((group, index) => {
    group
      .toUpperCase()
      .split("")
      .forEach((char) => {
        if (morseCodeDict[char]) {
          morseCodeDict[char].split("").forEach((symbol) => {
            if (symbol === ".") {
              scheduleBeep(dotLength);
            } else if (symbol === "-") {
              scheduleBeep(dashLength);
            }
            time += spaceBetweenSymbols;
          });
          time += spaceBetweenLetters;
        } else if (char === " ") {
          time += spaceBetweenWords;
        }
      });

    if (index < groups.length - 1) {
      time += spaceBetweenWords;
    }
  });

  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);
  oscillator.start();
  oscillator.stop(time);

  setTimeout(() => {
    if (!stopRequested) {
      onComplete(); // Call onComplete if playback wasn't stopped manually
    }
  }, (time - audioContext.currentTime) * 1000);
};

// Function to stop Morse code playback
export const stopMorseAudio = () => {
  if (audioContext) {
    stopRequested = true; // Set flag to stop playback
    audioContext.close();
    audioContext = null;
    oscillator = null;
    gainNode = null;
  }
};
